/**
 * Support API
 * Contact information and FAQs
 */

import { apiClient } from "./client";
import type {
  SupportContactResponse,
  SupportEmailsResponse,
  SupportFAQResponse,
} from "./types";

/**
 * Get support contact information
 * Returns general contact (office@enerquant.eu) and alert contact (alert@enerquant.eu)
 */
export async function getSupportContact(): Promise<SupportContactResponse> {
  return apiClient.get<SupportContactResponse>("/api/v1/support/contact");
}

/**
 * Get frequently asked questions
 */
export async function getSupportFAQs(): Promise<SupportFAQResponse> {
  return apiClient.get<SupportFAQResponse>("/api/v1/support/faq");
}

/**
 * Get support email addresses only (simplified endpoint)
 */
export async function getSupportEmails(): Promise<SupportEmailsResponse> {
  return apiClient.get<SupportEmailsResponse>("/api/v1/support/emails");
}
